/** @WORKAROUND CODE:
 * Очищает служебные узлы в ЕМД представляемые: 0.0.2x*/


module.exports = function () {

	var filter = {},
		enabled=true,
		filteredNodes,
		removedNodes,
		filteredProperties;

	filter.enabled=function(val){
		if (!arguments.length){
            return enabled;
		}
        enabled=val;
	};

	filter.filter = function (nodes, properties) {
		//console.log("servicesNodesFilter filter.filter = function (nodes, properties)", enabled, nodes, properties);
		if (enabled===false){
			filteredNodes=nodes;
			filteredProperties=properties;
      removedNodes=[];
			return;
		}
		var nodesToRemove = [];
		var newNodes = [];
		// todo: test and make it faster
		for (i = 0; i < nodes.length; i++) {
			var nodeId = nodes[i].id();
			newNodes.push(nodes[i]);
			if (nodes[i].type() === "owl:Class") {
				//console.log("if (nodes[i].type() === 'owl:Class')", nodes[i].iri());
				 if (["http://hbz.ru/ontologies/emd/sdmx", 
				 		 "http://hbz.ru/ontologies/emd/DataStructureDefinition",
				 	   "http://hbz.ru/ontologies/emd/HBZRootElement"].includes(nodes[i].iri())){
					nodes[i].visible(false);
//				 	nodesToRemove.push(nodeId);
				 }
				//  else {
				// 	newNodes.push(nodes[i]);
				// }
			}
		}
		console.log("filter servicesNodesFilter newNodes, nodesToRemove", newNodes, nodesToRemove)
		filteredNodes = newNodes;
		filteredProperties = properties;
		removedNodes = nodesToRemove;
	};


	// Functions a filter must have
	filter.filteredNodes = function () {
		return filteredNodes;
	};

	filter.removedNodes = function () {
		return removedNodes;
	};

	filter.filteredProperties = function () {
		return filteredProperties;
	};


	return filter;
};
